import { Component, OnInit, Input, Inject, SimpleChanges, OnChanges, Output, EventEmitter, HostBinding, Host } from '@angular/core';
import { IBannerButton } from './ibanner-button.interface';
import { IAssetMap } from 'src/app/asset-maps';
import { DomSanitizer } from '@angular/platform-browser';
import { BannerType } from './banner.type';

@Component({
  standalone: false,
  selector: 'banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnChanges {

  private get errorButtons(): IBannerButton[] {
    return [
      {
        text: 'Close',
        icon: this.assetMap.cancelIcon,
        action: () => this.close.emit()
      }
    ];
  }

  private get confirmationButtons(): IBannerButton[] {
    return [
      {
        text: 'Yes',
        icon: this.assetMap.acceptIcon,
        action: () => this.yes.emit()
      },
      {
        text: 'No',
        icon: this.assetMap.cancelIcon,
        action: () => this.no.emit()
      }
    ];
  }

  private get infoButtons(): IBannerButton[] {
    return [
      {
        text: 'Close',
        icon: this.assetMap.cancelIcon,
        action: () => this.close.emit()
      }
    ];
  }

  @HostBinding('style.background-color')
  private get backgroundColor() {
    return this.sanitizer.bypassSecurityTrustStyle(this.color);
  }

  @HostBinding('style.display')
  private get display() {
    return this.visible ? null : 'none';
  }

  @Input() visible: boolean;
  @Input() icon: string;
  @Input() message: string;
  @Input() type: BannerType;
  @Input() buttons?: IBannerButton[] = [];
  @Input() color?: string;

  @Output() close = new EventEmitter<any>();
  @Output() yes = new EventEmitter<any>();
  @Output() no = new EventEmitter<any>();

  constructor(@Inject('SVG_MAP') private assetMap: IAssetMap,
    private sanitizer: DomSanitizer) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.type && this.type !== 'custom') {
      this.buttons = this.getButtons(this.type);
      this.color = this.getColor(this.type);
      this.icon = this.getIcon(this.type);
    }
  }

  getIcon(type: string): string {
    switch (type) {
      case 'error':
        return '!';
      case 'confirmation':
        return '?';
      case 'info':
        return 'i';
      default:
        throw { message: `No default buttons for banner type ${type}` };
    }
  }

  getButtons(type: string): IBannerButton[] {
    switch (type) {
      case 'error':
        return this.errorButtons;
      case 'confirmation':
        return this.confirmationButtons;
      case 'info':
        return this.infoButtons;
      default:
        throw { message: `No default buttons for banner type ${type}` };
    }
  }

  getColor(type: string): string {
    switch (type) {
      case 'error':
        return 'var(--banner-error)';
      case 'confirmation':
        return 'var(--banner-confirmation)';
      case 'info':
        return 'var(--banner-info)';
      default:
        throw { message: `No default color for banner type ${type}` };
    }
  }
}
